var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property, query, state } from "lit/decorators.js";
import { LitElement, html } from "lit";
import mailingListComponentsCss from "./mailing-list.css.js";
import sharedCss from "../../css/shared.css.js";
let MailingList = class MailingList extends LitElement {
    constructor() {
        super();
        this.error = '';
        this.email = sessionStorage.getItem('pb33f_mailing_list_email');
        this.apiURL = 'https://api.pb33f.io/mailing-list/subscribe';
        this.promiseMessage = 'No junk, no sales, no spam. Just updates about pb33f.';
        this.thanksMessage = 'We promise to only send you updates about pb33f.';
    }
    updated() {
        if (this.email) {
            this.subscribed.classList.add('show');
            this.unsubscribed.classList.add('hide');
        }
        else {
            this.subscribed.classList.add('hide');
            this.unsubscribed.classList.add('show');
        }
    }
    subscribe() {
        if (this.emailInput.value == "") {
            this.emailInput.classList.add('error-input');
            this.error = "Email is empty";
            this.mailingListError.classList.add('show');
            this.mailingListPromise.classList.add('hide');
            return;
        }
        let emailRegEx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegEx.test(this.emailInput.value)) {
            this.emailInput.classList.add('error-input');
            this.error = "Not a valid email address";
            this.mailingListError.classList.add('show');
            this.mailingListPromise.classList.add('hide');
            return;
        }
        async function subscribeToList(email, url) {
            const response = await fetch(`${url}?email=${email}`);
            if (!response.ok) {
                let json = await response.json();
                return Promise.reject(json);
            }
            return response.json();
        }
        this.emailSubmit.disabled = true;
        this.emailSubmit.loading = true;
        this.mailingListError.classList.remove('show');
        this.emailInput.classList.remove('error-input');
        subscribeToList(this.emailInput.value, this.apiURL).then((response) => {
            this.email = response.email;
            this.subscribed.classList.remove('hide');
            this.subscribed.classList.add('show');
            this.unsubscribed.classList.add('hide');
            sessionStorage.setItem('pb33f_mailing_list_email', this.email);
        }, (error) => {
            this.emailSubmit.disabled = false;
            this.emailSubmit.loading = false;
            this.emailInput.classList.add('error-input');
            this.mailingListError.classList.add('show');
            this.mailingListPromise.classList.add('hide');
            this.error = error.detail;
        });
    }
    render() {
        return html `
            <div class="mailing-list">
                <div class="subscribed">
                    <header>
                        <sl-icon name="check-lg"></sl-icon>
                        <strong>Subscribed!</strong>
                    </header>
                    Thanks <strong>${this.email}</strong>, ${this.thanksMessage}
                </div>
                <div class="unsubscribed">
                    <span class="mailing-list-header"><strong>Subscribe</strong> for updates</span>
                    <sl-input type="email" placeholder="Email" size="small" id="email-input"></sl-input>
                    <sl-button style="width: 100%" id="email-submit" type="primary" size="small"
                               @click=${this.subscribe}>Subscribe
                    </sl-button>
                    </di>
                    <div class="mailing-list-promise">${this.promiseMessage}</div>
                    <div class="mailing-list-error">
                        <span class="error-title">ERROR</span><br/>
                        ${this.error}
                    </div>
                </div>
            </div>
        `;
    }
};
MailingList.styles = [sharedCss, mailingListComponentsCss];
__decorate([
    property()
], MailingList.prototype, "apiURL", void 0);
__decorate([
    property()
], MailingList.prototype, "thanksMessage", void 0);
__decorate([
    property()
], MailingList.prototype, "promiseMessage", void 0);
__decorate([
    state()
], MailingList.prototype, "email", void 0);
__decorate([
    query('#email-input')
], MailingList.prototype, "emailInput", void 0);
__decorate([
    query('.subscribed')
], MailingList.prototype, "subscribed", void 0);
__decorate([
    query('.unsubscribed')
], MailingList.prototype, "unsubscribed", void 0);
__decorate([
    query('.mailing-list-promise')
], MailingList.prototype, "mailingListPromise", void 0);
__decorate([
    query('#email-submit')
], MailingList.prototype, "emailSubmit", void 0);
__decorate([
    query(".mailing-list-error")
], MailingList.prototype, "mailingListError", void 0);
__decorate([
    property()
], MailingList.prototype, "error", void 0);
MailingList = __decorate([
    customElement('pb33f-mailing-list')
], MailingList);
export { MailingList };
